import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function formatShares(shares: number): string {
	return parseFloat(shares.toFixed(4)).toString()
}
